module.exports = __webpack_public_path__ + "static/trig_005-e9554de26486916a3a838536163311ec.webp";